var states = {
  ruleInfo: {},
  menuList: '',
  index: '' // 默认展开菜单key
};

var mutations = {
  SET_RULE_INFO: function SET_RULE_INFO(state, data) {
    state.ruleInfo = data;
  },
  SET_MENU_LIST: function SET_MENU_LIST(state, data) {
    state.menuList = data;
  },
  SET_MENU_KEY: function SET_MENU_KEY(state, data) {
    state.index = data;
  }
};
var actions = {
  setRuleInfo: function setRuleInfo(_ref, ruleInfo) {
    var commit = _ref.commit;
    commit('SET_RULE_INFO', ruleInfo);
  },
  setMenuList: function setMenuList(_ref2, menuList) {
    var commit = _ref2.commit;
    commit('SET_MENU_LIST', menuList);
  },
  setMenuKey: function setMenuKey(_ref3, index) {
    var commit = _ref3.commit;
    commit('SET_MENU_KEY', index);
  }
};
export default {
  namespaced: true,
  state: states,
  mutations: mutations,
  actions: actions
};